$(document).ready(function(){

	// Shop location map (the .map box in the FIND_US snippet) - Leaflet with CARTO basemap tiles
	var shop = [53.3907413, -1.4819023];

	function initialiseMap(element) {

		var map = L.map(element, {
			center			: shop,
			zoom			: 15,
			scrollWheelZoom	: true,
			zoomControl		: false
		});

		// CARTO "Positron" light grey basemap - needs the API key (set in settings.php, output in footer.tpl);
		// attribution is required by CARTO and OpenStreetMap
		L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=' + encodeURIComponent(CARTO_BASEMAP_KEY), {
			subdomains	: 'abcd',
			maxZoom		: 20,
			attribution	: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
		}).addTo(map);

		L.marker(shop, {
			icon: L.icon({
				iconUrl		: '/images/map-pointer.png',
				iconSize	: [58, 79],
				iconAnchor	: [29, 79]
			}),
			alt: "Dick's Board Store"
		}).addTo(map);

		// front-layout.js resizes .map to match the text column beside it (and that column can grow as fonts and images load).
		// Leaflet only draws tiles for the size it last measured, so re-measure whenever the box changes size -
		// otherwise part of the map is left blank or torn
		var remeasure = $.debounce(100, function(){
			map.invalidateSize();
		});

		if (window.ResizeObserver) {
			new ResizeObserver(remeasure).observe(element);
		}

		$(window).on('resize orientationchange load', remeasure);
	}

	$('.map').each(function(){

		var element = this;

		// The map is usually well down the page - only start it (and download its tiles) when it's about to be seen
		if (!window.IntersectionObserver) {
			initialiseMap(element);
			return;
		}

		var observer = new IntersectionObserver(function(entries){
			if (entries[0].isIntersecting) {
				observer.disconnect();
				initialiseMap(element);
			}
		}, { rootMargin: '300px' });

		observer.observe(element);
	});

});
